import React, { forwardRef } from 'react';
import { Avatar, Typography, Tooltip } from 'antd';
import BaseModal from 'components/BaseModal';
import { CellRenderers } from 'utils/tableUtils';
import CommentComponent from 'components/CommentComponent';

const HistoryPopup = forwardRef(({data=[], policyName, afterClose}, ref) => {

    const getChangeText = (item) => {
        const change = item.fieldName;
        let content = "";
        switch(change) {
            case "name":
                content = `Changed policy name to ${item.newValue}`;
                break;
            case "status":
                content = "Policy " + (item.newValue === true ? "Enabled" : "Disabled");
                break;
            default:
                content = "";
            
        }
        return <Typography.Text>{content}</Typography.Text>;
    }

    const baseModalProps = {
        title: <>History of {policyName} </>,
        footer: null
    }

    const getItemDataProps = item => {
        const userName = item.updatedBy || "";
        const matches = userName.match(/\b(\w)/g);
        const content = getChangeText(item);
        return {
            author: item.updatedBy,
            avatar: <Avatar size="small">{matches?.join("") || userName[0]}</Avatar>,
            content: (
                <>
                    {content}
                    <br />
                    <Typography.Text strong>Note:</Typography.Text> {CellRenderers.VALUE_OR_NA(item.description)}
                </>
            ),
            datetime: (
                <Tooltip title={CellRenderers.TIME_RELATIVE(item.updatedOn)} placement="right">
                    {CellRenderers.TIME(item.updatedOn)}
                </Tooltip>
            )
        }
    }

    return (
        <BaseModal ref={ref} modalProps={baseModalProps} afterClose={afterClose}>
            <CommentComponent
                commentList={data}
                getItemDataProps={getItemDataProps}
            />
        </BaseModal>
  );
})

export default HistoryPopup;
